import styled from '@emotion/styled';
import { Card } from '@presentation/components';

export const Wrapper = styled.div`
  min-height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => props.theme.color.blue.default};
`;

export const SsoButtonIconWrapper = styled.div`
  margin-right: 12px;
  width: 20px;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledCard = styled(Card)`
  text-align: center;
`;
